<template>
  <BaseModal
    :heading="t('global.actions.send_payment_link')"
    small
    useForm
    @submit="send"
    @close="emit('close')"
  >
    <Form
      v-model:emailAddress="emailAddress"
      v-model:emailSubject="emailSubject"
      v-model:editorContent="editorContent"
      :editorHeight="250"
    />
    <template #footer>
      <BaseButton
        color="inverted"
        @click="emit('close')"
        v-test="'send-payment-link-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isSending"
        submitForm
        v-test="'send-payment-link-submit'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash } from '@/helpers/ui';
import Form from './sale-email/Form.vue';

const { t } = useI18n();

const props = defineProps<{
  orderId: string;
  email?: string;
}>();

const emit = defineEmits(['close']);

const isSending = ref(false);

const emailAddress = ref(props.email || '');
const emailSubject = ref('');
const editorContent = ref('');

const { mutate: sendPaymentLink } = useMutation(
  gql`
    mutation sendPaymentLink($input: SendPaymentLinkInput!) {
      sendPaymentLink(input: $input) {
        errors
      }
    }
  `,
);

const send = () => {
  isSending.value = true;

  sendPaymentLink({
    input: {
      customMessage: editorContent.value,
      customSubject: emailSubject.value,
      email: emailAddress.value,
      orderId: props.orderId,
    },
  }).then(({ data: { sendPaymentLink } }: any) => {
    if (!sendPaymentLink.errors) {
      flash(t('global.flash.email_sent'));
    }
    emit('close');
    isSending.value = false;
  });
};
</script>
